import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';

/**
 * Generated class for the TwitterLogout page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */
// @IonicPage()
@Component({
  selector: 'page-twitter-logout',
  templateUrl: 'twitter-logout.html',
})
export class TwitterLogout {

  constructor(public navCtrl: NavController, public navParams: NavParams) {
  }

  ionViewDidLoad() {
    // console.log('ionViewDidLoad TwitterLogout');
  }

}



// WEBPACK FOOTER //
// ./src/pages/twitter-logout/twitter-logout.ts